/*!

 =========================================================
 * Vue Now UI Kit Pro - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-kit-pro
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from "vue";
import App from "./App.vue";
import router from "@/routes/router";
import "./registerServiceWorker";
//plugins
import NowUIKit from './plugins/now-ui-kit';
import TrustpilotPlugin from 'vue-trustpilot'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueGtag from "vue-gtag"

Vue.use(VueGtag, {
  config: { id: "G-1B9WJ9F00Z" }
}, router);

const toastOptions = {
    // You can set your default options here
}

Vue.use(Toast, toastOptions)

const carouselWidget = {
 templateId: '5419b6a8b0d04a076446a9ad',
 businessunitId: '61b64eee8dd10a4cbfcc34a9',
 reviewUrl: 'https://uk.trustpilot.com/review/jgestates.co.uk',
 locale: 'en-gb',
 // ...more Trstupilot options in camel case
}

const reviewsListWidget = {
 templateId: '5419b6a8b0d04a076446a9ad',
 businessunitId: '61b64eee8dd10a4cbfcc34a9',
 reviewUrl: 'https://uk.trustpilot.com/review/jgestates.co.uk',
 locale: 'en-gb',
 // ...more Trstupilot options in camel case
}

const options = {
  widgets: {
    carousel: carouselWidget,
    list: reviewsListWidget
  }

}
 
Vue.config.productionTip = false;
Vue.use(NowUIKit);
Vue.use(TrustpilotPlugin, options)
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
